import { z } from 'zod';
import { GIT_RULES_MAX, GitBranchFormat, GitBranchTypeMap, GitProjectSettings, GitRule, } from './git.js';
/**
 * Đọc / ghi `git_project_settings` của một dự án — APM-GIT-e,
 * docs/plan-git-integration.md §4.1, §8.3.
 *
 * Tệp riêng (không nối vào `git.ts`) vì các task `APM-GIT-*` chạy song song cùng
 * thêm kiểu; hình của **giá trị** vẫn là `GitProjectSettings` ở `git.ts`.
 */
/**
 * `GET /projects/:projectId/git/settings` (`git:read`).
 *
 * Dự án chưa ai lưu cấu hình ⇒ `settings` là `DEFAULT_GIT_PROJECT_SETTINGS` và
 * `updatedAt: null` — "chưa có" là một giá trị, không phải một khoảng trống
 * (bẫy "endpoint trả `null` trần").
 *
 * ⚠️ Không nhận asOf: cấu hình hiện hành của công cụ, không phải một đại lượng
 * của dự án theo thời gian (§7.3 — màn Cài đặt). Lịch sử của nó nằm ở event
 * `git_settings.changed`.
 */
export const GitProjectSettingsView = z.object({
    settings: GitProjectSettings,
    /** `null` = chưa có hàng `git_project_settings` — đang dùng mặc định. */
    updatedAt: z.iso.datetime().nullable(),
});
/**
 * `PUT /projects/:projectId/git/settings` (`git:manage`) — gửi **trọn bộ**.
 *
 * Ba khoá đều **bắt buộc**, khác `GitProjectSettings` (khoá vắng lấy mặc định):
 * màn định dạng tên nhánh và màn luật (`APM-GIT-h`) cùng ghi vào một hàng, nên
 * một thân chỉ mang `branchFormat` mà được điền `rules: []` là màn này lặng lẽ
 * xoá luật của màn kia. Bên gửi phải đọc cấu hình hiện có rồi gửi lại phần mình
 * không sửa.
 *
 * Luật cấp object ("không hai luật cùng trigger + phạm vi nhánh") vẫn chạy ở
 * đúng một chỗ: giá trị được đưa lại qua `GitProjectSettings` và lỗi của nó
 * được chép sang đây nguyên `path`.
 */
export const SaveGitProjectSettingsInput = z
    .object({
    branchFormat: GitBranchFormat,
    branchTypeMap: GitBranchTypeMap,
    rules: z.array(GitRule).max(GIT_RULES_MAX),
})
    .superRefine((value, ctx) => {
    const whole = GitProjectSettings.safeParse(value);
    if (whole.success)
        return;
    for (const issue of whole.error.issues) {
        ctx.addIssue({ code: 'custom', path: [...issue.path], message: issue.message });
    }
});
//# sourceMappingURL=git-settings.js.map